<template>
	<div :class="containerClass" @click="onWrapperClick">

        <IKLoader :isVisible="exibirLoader"/>
       
        <AppTopBar @menu-toggle="onMenuToggle" :usuarioLogado="usuarioLogado"/>

        <transition name="layout-sidebar">
            <div :class="sidebarClass" @click="onSidebarClick" v-show="isSidebarVisible()">
                <div class="layout-logo">
                    <router-link to="/">
                        <img alt="Logo" src="@/assets/logo.png" />
                    </router-link>
                </div>         
                <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
            </div>
        </transition>

		<div class="layout-main">           
			<router-view />
		</div>

		<AppFooter />  

        <Toast />
        
	</div>
    
</template>

<script>
import AppTopBar from '@/components/template/AppTopbar.vue';
import AppMenu from '@/components/template/AppMenu.vue';
import AppFooter from '@/components/template/AppFooter.vue';
import http from '@/plugins/axios/axios';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            usuarioLogado: '',
            exibirLoader: false,
            layoutMode: 'static',
            layoutColorMode: 'dark',
            //layoutColorMode: 'light',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            menu : []
        }
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        }
    },
    methods: {
        ...mapGetters('sessao', ['getUsuario', 'getPermissoes']), 
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
					if(this.mobileMenuActive === true) {
						this.overlayMenuActive = true;
					}

                    this.overlayMenuActive = !this.overlayMenuActive;
					this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
		onLayoutChange(layoutMode) {
			this.layoutMode = layoutMode;
		},
		onLayoutColorChange(layoutColorMode) {
			this.layoutColorMode = layoutColorMode;
		},
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth > 1024;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
                else
                    return true;
            }
            else {
                return true;
            }
        },
        configurarInterceptorAxios() {
            let vueInstance = this;            
            http.interceptors.request.use(function(config) {  
                let arrUrl = config.url.split('?');              
                if(arrUrl.length == 1) {
                    vueInstance.exibirLoader = true; 
                } else {
                    let params = arrUrl[1].split('&');
                    if(!params.includes('wt=f')) {
                        vueInstance.exibirLoader = true;
                    }
                }            
                return config;
            }, function(erro) {
                vueInstance.exibirLoader = false;               
                return Promise.reject(erro);
            });  
            http.interceptors.response.use((response) => {
                vueInstance.exibirLoader = false;
                return response
            }, function(erro) {
                vueInstance.exibirLoader = false;
                return Promise.reject(erro);
            });      
        },    
        carregarMenu() {
            let agent =  JSON.parse(sessionStorage.getItem('AGENT_WEB_MOBILE'));
            if(agent && agent.mobile) {
                this.menu = [
                    { label: 'Home', icon: 'pi pi-fw pi-home', to: '/' },
                    { label: 'Espelho', icon: 'pi pi-fw pi-folder', to: '/mob/espelho' },
                    { label: 'Solicitações', icon: 'pi pi-fw pi-folder', to: '/mob/solicitacoes' }
                ];
            } else {
                this.menu = [
                    { label: 'Home', icon: 'pi pi-fw pi-home', to: '/' },
                    { label: 'Espelho', icon: 'pi pi-fw pi-folder', to: '/espelho' },
                    { label: 'Solicitações', icon: 'pi pi-fw pi-folder', to: '/solicitacoes' }
                ];
            }
            
        }
    },
    computed: {
        containerClass() {       
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
				'p-input-filled': this.$appState.inputStyle === 'filled',
				'p-ripple-disabled': this.$primevue.ripple === false
            }];
        },
        sidebarClass() {
            return ['layout-sidebar', {
                'layout-sidebar-dark': this.layoutColorMode === 'dark',
                'layout-sidebar-light': this.layoutColorMode === 'light'
            }];
        },
        logo() {
            //return (this.layoutColorMode === 'dark') ? "assets/layout/images/logo-white.svg" : "assets/layout/images/logo.svg";
            return "./assets/logo_ikponto.jpg";
        }
    },
    created() {
        this.carregarMenu();
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    mounted() {
        this.configurarInterceptorAxios();
        this.usuarioLogado = this.getUsuario().nome;
    },
    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,       
        'AppFooter': AppFooter,
    }
}
</script>

<style lang="scss">

    .p-toast.p-toast-topright {
        z-index: 1000;
        top: 70px;
    }

</style>